import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as z from 'zod';
import { SupportPage } from '@/pages/support';
import { requireAuth } from '../require-auth';

/**
 * URL state for the Support screen. `conversationId` is the open thread — in
 * the URL (CLAUDE.md state-boundary table) so a thread is linkable and the back
 * button steps back through the ones you opened. Absent means "no thread yet",
 * which the desktop layout resolves to the first conversation.
 */
const supportSearchSchema = z.object({
  conversationId: z.string().optional(),
});

// No loader prefetch: the inbox is unscoped, but the thread query is keyed by
// `conversationId`, which the desktop layout only picks once the inbox lands.
// The page's own queries own the fetch and the panels render their skeletons.
export const Route = createFileRoute('/support')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  validateSearch: supportSearchSchema,
  component: SupportRoute,
});

function SupportRoute() {
  const { conversationId } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <SupportPage
      conversationId={conversationId}
      onSelectConversation={(id) => {
        void navigate({
          search: (prev) => ({ ...prev, conversationId: id }),
          // Auto-selecting the first thread on desktop shouldn't leave a
          // history entry — otherwise Back re-lands on the same screen.
          replace: id !== undefined && conversationId === undefined,
        });
      }}
    />
  );
}
